import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../../../NotFound'

import { AbilityContext } from '../../../../components/Ability'
import DistributionChannelsListPage from './Features/DistributionChannelsList'


const DistributionChannelsPage = () => {
  const ability = useContext(AbilityContext)
  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('read', 'Setting') ? < DistributionChannelsListPage /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default DistributionChannelsPage
